const photosTemplate = require('20220101/templates/widgets/personalized/photos.hbs');
const morePhotosTemplate = require('20220101/templates/widgets/personalized/more-photos.hbs');
const indexTemplate = require('20220101/templates/widgets/personalized/index.hbs');
import widgetMixin from "./widget-mixin.js";
import feedURL from "./feed-url.js";

class PersonalizedWidget extends widgetMixin(HTMLElement) {
  constructor() {
    super();

    this.photos = [];
    this.page = 1;
  }

  beforeFetch() {
    super.beforeFetch();
    if (this.loadMoreEnabled) {
      this.hideLoadMoreLink();
      this.showLoadingSpinner();
    }
  }

  afterFetch() {
    super.afterFetch();
    if (this.loadMoreEnabled) {
      this.hideLoadingSpinner();

      if (this.page) {
        this.showLoadMoreLink();
      }
    }
  }

  fetchPhotos() {
    if (this.fetchingPhotos || this.page === null) { return Promise.resolve() }
    if (this.notFirstFetch && !this.loadMoreEnabled) {
      return Promise.resolve();
    }
    this.beforeFetch();

    let params, updateNextPage;

    if (this.notFirstFetch) {
      params = { per: 30, padding: 10, page: this.page }
      updateNextPage = true;
    } else {
      params = { per: 10, padding: 0, page: this.page }
      updateNextPage = false;
      this.notFirstFetch = true;
    }

    this.fetchingPhotos = true;



    let url = feedURL(this.photosURL, params);

    return fetch(url)
      .then(response => response.json())
      .then((data) => {
        this.photos.push(...data.photos);
        this.processPhotos(data);

        if (updateNextPage) {
          this.page = data.meta.nextPage;
        }

        this.afterFetch();
      });
  }

  bindEvents() {
    if (!this.loadMoreLink) { return }

    this.loadMoreLink.addEventListener("click", (e) => {
      e.preventDefault();
      this.fetchPhotos();
    });
  }

  render() {
    const renderedIndex = indexTemplate({loadMoreEnabled: this.loadMoreEnabled, preferences: this.preferences, assetHost: this.settings.assetHost, uuid: this.uuid});
    this.shadow.innerHTML = renderedIndex;
    this.appendCustomCSS();

    this.bindEvents();
  }

  appendPhotos(photos) {
    const template = this.photos.length > 10 ? morePhotosTemplate : photosTemplate;
    const renderedPhotos = template({photos: photos, brandPhotoURL: this.brandPhotoURL, brandPhotoClickURL: this.brandPhotoClickURL, preferences: this.preferences});
    this.shadow.querySelector('.l2h-photos').insertAdjacentHTML('beforeend', renderedPhotos);
    this.renderHeader();
  }

  showLoadMoreLink() {
    this.loadMoreLink.classList.remove("l2h-hidden");
  }

  hideLoadMoreLink() {
    this.loadMoreLink.classList.add("l2h-hidden");
  }

  showLoadingSpinner() {
    this.spinner.classList.remove("l2h-hidden");
  }

  hideLoadingSpinner() {
    this.spinner.classList.add("l2h-hidden");
  }

  get brandPhotoURL() {
    return this.getAttribute("brand-photo-url") || `${this.settings.appURL}images/embed/personalized-widget-default.png`;
  }

  get brandPhotoClickURL() {
    return this.getAttribute("brand-photo-click-url") || this.settings.galleryURL;
  }

  get loadMoreEnabled() {
    return !!this.getAttribute("load-more-enabled") || false
  }

  get loadMoreLink() {
    return this.shadow.querySelector('[data-l2h-load-more]');
  }

  get spinner() {
    return this.shadow.querySelector(".l2h-loading-spinner");
  }

  static get observedAttributes() {
    return ["brand-photo-click-url", "brand-photo-url"].concat(super.observedAttributes)
  }
}

customElements.define("l2h-personalized-widget", PersonalizedWidget);
